import { render, staticRenderFns } from "./PdpaMenu.vue?vue&type=template&id=2bbcd35d&scoped=true"
import script from "./PdpaMenu.vue?vue&type=script&lang=js"
export * from "./PdpaMenu.vue?vue&type=script&lang=js"
import style0 from "./PdpaMenu.vue?vue&type=style&index=0&id=2bbcd35d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcd35d",
  null
  
)

export default component.exports